export default {
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '22.5px'
}
